import { Chart } from 'highcharts-vue';
<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">LISTA DE AEREO SEGUN SU ID DE RUBRO</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="id_rubro">Id rubro</label>
              <select class="form-control" id="id_rubro" v-model="id_rubro">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
          <div class="col">
            <button
              class="btn btn-info mt-4"
              type="button"
              @click="getAereo(id_rubro)"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div class="mt-5" v-if="aereos.length > 0">
          <line-chart
            :chartData="aereos"
            :options="chartOptions"
            label="aereos"
          ></line-chart>
        </div>
        <div class="pt-5">
          <div class="table-responsive">
            <table class="table">
              <thead class="thead-active">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Empresa Razon Social</th>
                  <th scope="col">Id Empresa</th>
                  <th scope="col">Partes</th>
                  <th scope="col">Total Registros</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aereo, index) in aereos" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ aereo.emp_razon_social }}</td>
                  <td>{{ aereo.id_empresa }}</td>
                  <td>{{ aereo.partes }}</td>
                  <td>{{ aereo.total_registros }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "../../components/graficos/LineChart";
export default {
  components: { LineChart },
  data() {
    return {
      aereos: {},
      id_rubro: 0,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    async getAereo(id_rubro) {
      try {
        let res = await this.axios.get(`/reporteaereo/${id_rubro}`);
        this.aereos = res.data.contenido;
        console.log(this.aereos);
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
  },
  mounted(id_rubro) {
    this.getAereo(id_rubro);
  },
};
</script>
